import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import inputRules from '@/mixins/input-rules';
import ActionParametersEditDialog from './actionParametersEditDialog.vue';
export default {
  name: 'ActionsEditor',
  components: {
    ActionParametersEditDialog
  },
  mixins: [inputRules],
  props: {
    value: {
      type: Array,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      newActionLabel: '',
      newActionAction: null,
      actionParametersOpenedIndex: null,
      addFormValid: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    definedActions() {
      const clone = cloneDeep(this.value);
      return Array.isArray(clone) ? clone : [];
    },
    actionDefinitions() {
      return [{
        type: 'url.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.url.open.label'),
        parameters: [{
          key: 'url',
          label: this.$t('Dashboards.components.actionsEditor.actions.url.open.parameters.url.label'),
          type: 'string'
        }, {
          key: 'openInNewTab',
          label: this.$t('Dashboards.components.actionsEditor.actions.url.open.parameters.newTab.label'),
          type: 'boolean',
          default: true
        }]
      }, {
        type: 'twin.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.twin.open.label'),
        parameters: [{
          key: 'useOpenedTwin',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.useOpenedTwin.label'),
          type: 'boolean',
          default: true
        }, {
          key: 'twinId',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.twinId.label'),
          type: 'twin.id',
          if: '!useOpenedTwin'
        }, {
          key: 'openInNewTab',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.newTab.label'),
          type: 'boolean',
          default: true
        }]
      }, {
        type: 'dashboard.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.dashboard.open.label'),
        parameters: [{
          key: 'nestedDashboard',
          type: 'nestedDashboard'
        }]
      }];
    },
    openedActionParameterDefinitions() {
      if (!this.showActionParametersDialog) {
        return [];
      }
      const actionDefinition = this.actionDefinitions.find(actionItem => actionItem.type === this.definedActions[this.actionParametersOpenedIndex].action);
      if (!actionDefinition) {
        console.error('Action definition not found');
        return [];
      }
      return actionDefinition.parameters || {};
    },
    showActionParametersDialog: {
      get() {
        return this.actionParametersOpenedIndex !== null;
      },
      set(value) {
        if (value) {
          throw new Error('Cannot open the dialog like this...');
        }
        this.actionParametersOpenedIndex = null;
      }
    },
    openedAction() {
      return this.definedActions[this.actionParametersOpenedIndex] || {};
    }
  },
  methods: {
    addNewAction() {
      if (!this.addFormValid) {
        this.$refs.addForm.validate();
        return;
      }
      const newAction = {
        label: this.newActionLabel,
        action: this.newActionAction,
        parameters: {}
      };
      const newActions = [...this.definedActions, newAction];
      this.$emit('input', newActions);
    },
    updateAction(index, key, value) {
      const clone = cloneDeep(this.value);
      set(clone, `[${index}].${key}`, value);
      this.$emit('input', clone);
    },
    openActionParameters(index) {
      this.actionParametersOpenedIndex = index;
    },
    removeAction(index) {
      const newActions = this.definedActions.filter((_, i) => i !== index);
      this.$emit('input', newActions);
    },
    onParametersUpdated(parameters) {
      this.updateAction(this.actionParametersOpenedIndex, 'parameters', parameters);
      this.actionParametersOpenedIndex = null;
    }
  }
};